/**
 * Minimal CMP adapter. Replace internals to match your CMP.
 * Looks for window.__DW_CMP with shape { analyticsAllowed: boolean, on(event, fn) }.
 */
export function makeCmpConsentProvider() {
    const listeners = new Set();
    const getCmp = () => globalThis.__DW_CMP;
    function allowed() {
        try {
            return getCmp()?.analyticsAllowed === true;
        }
        catch {
            return false;
        }
    }
    function onChange(cb) {
        listeners.add(cb);
        try {
            getCmp()?.on?.('change', () => cb(allowed()));
        }
        catch {
            /* noop */
        }
        return () => listeners.delete(cb);
    }
    return { analyticsAllowed: allowed, onChange };
}
//# sourceMappingURL=consent-cmp.js.map